export default __webpack_public_path__ + "static/media/1981.1a171e73.png";